import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  variant?: 'gray' | 'white' | 'black';
  noLink?: boolean;
}

export function Logo({ className = '', variant = 'gray', noLink = false }: LogoProps) {
  const logoFile = variant === 'white' ? 'LogoBasicWhite.svg' : variant === 'black' ? 'LogoBasicBlack.svg' : 'LogoBasicGlay.svg';

  const logoImage = (
    <img
      src={`/img/Logo/${logoFile}`}
      alt="TaStacK Logo"
      style={{ height: '50px', width: 'auto' }}
    />
  );

  if (noLink) {
    return <div className={`flex items-center ${className}`}>{logoImage}</div>;
  }

  return (
    <Link to="/" className={`flex items-center ${className}`}>
      {logoImage}
    </Link>
  );
}

// Compact version for mobile (smaller size for compact header)
export function LogoCompact({ className = '', variant = 'gray', noLink = false }: LogoProps) {
  const logoFile = variant === 'white' ? 'LogoBasicWhite.svg' : variant === 'black' ? 'LogoBasicBlack.svg' : 'LogoBasicGlay.svg';

  const logoImage = (
    <img
      src={`/img/Logo/${logoFile}`}
      alt="TaStacK Logo"
      style={{ height: '24px', width: 'auto' }}
    />
  );

  if (noLink) {
    return <div className={`flex items-center ${className}`}>{logoImage}</div>;
  }

  return (
    <Link to="/" className={`flex items-center ${className}`}>
      {logoImage}
    </Link>
  );
}
